export const styles = (theme) => ({
    tableBorder: {
        border: `1px solid ${theme.palette.border.thin}`,
        fontSize: '0.85rem',
        borderRadius: '8px',
    },

    tableBottomBorder: {
        borderBottom: `1px solid ${theme.palette.border.thin}`,
        fontSize: '0.85rem',
    },

    tablePagination: {
        "& .MuiPaginationItem-root": {
            color: "#333",
            background: "#fff",
            borderRadius: "5px",
        },
        "& .Mui-selected": {
            backgroundColor: "#FFA2001A" + "!important",
            color: "#F59E0B !important",
            fontWeight: "bold",
            borderRadius: "5px",
            border: "1px solid #F59E0B !important",
        },
        "& .MuiPaginationItem-root:hover": {
            backgroundColor: "#f0f0f0",
        },

        "& .MuiPaginationItem-previousNext": {
            color: "#F59E0B",
        },
        // Customizing the active arrows (when hovered or selected)
        "& .MuiPaginationItem-previousNext:hover": {
            color: "#F59E0B",
        },
    }
});

export const logoutStyles = (theme) => ({
    rootDiv: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        my: 2,
    },

    title: {
        fontWeight: "bold",
        fontSize: "1.4rem",
        textAlign: "center",
        pb: 1,
    },

    subtitle: {
        textAlign: "center",
        fontSize: "1rem",
        color: "text.secondary",
    },

    btnDiv: {
        justifyContent: "center",
        gap: 2,
        pb: 2
    }
})